<script setup lang="ts">
import { computed } from 'vue';
import { useRecipeImageUrl } from '@shared/app/composables/useRecipeImageUrl';

const { createRecipeMainImageUrl } = useRecipeImageUrl();

const props = withDefaults(
  defineProps<{
    oldIdentifier: string;
    recipeId: number;
    filename?: string | null;
    energy: number;
    title: string;
    tags?: string[];
    imageWidth?: number;
    imageHeight?: number;
    rank?: number;
  }>(),
  {
    filename: undefined,
    tags: () => [],
    imageWidth: 375,
    imageHeight: 300,
    rank: undefined,
  },
);

const mainImageUrl = computed(() => {
  if (props.filename) {
    return createRecipeMainImageUrl({
      recipeId: props.recipeId,
      filename: props.filename,
      w: props.imageWidth,
      h: props.imageHeight,
    });
  }
  return undefined;
});
</script>

<template>
  <NuxtLink
    :to="`/public/article/recipe/${oldIdentifier}`"
    class="h-full flex flex-col hover:opacity-70 duration-300 relative"
  >
    <AtomsRankBadge v-if="rank && rank <= 3" :rank="rank" />
    <div data-testid="recipe-image">
      <img
        v-if="mainImageUrl"
        :src="mainImageUrl"
        class="rounded-t w-full object-cover aspect-[375/300]"
      />
      <AtomsPlaceholderImage
        v-else
        class="w-full object-cover aspect-[375/300] rounded-t bg-white"
      />
    </div>

    <div
      class="border border-t-0 border-b-2 rounded-b pt-2 border-cream-400 p-2 flex flex-col flex-grow bg-white"
    >
      <div class="mb-1 flex items-baseline text-pink-400">
        <img src="~/assets/img/fire.png" class="mr-1 relative top-[3px] w-5" />
        <span class="font-bold text-sm">{{ energy }}</span>
        kcal
      </div>

      <h3 class="font-bold text-gray-500">{{ title }}</h3>

      <div v-if="tags.length" class="mt-1 text-sm text-brown-300 line-clamp-1">
        {{ tags.join('、') }}
      </div>
    </div>
  </NuxtLink>
</template>
